import { call, put, takeLeading } from 'redux-saga/effects'
import getCourse from 'api/courses/Get'
import { onHttpError } from 'helpers/access.helper'
import { ICourseModel } from 'models/course.model'
import enrolCreate from 'api/enrols/Create'
import { CourseStateType, CourseType } from 'enum'
import * as fromActions from '../../actions/courses.action'

function handleGetCourse(courseId: number) {
  return getCourse(courseId)
}

function* getCourseAndCreateEnrol(action: fromActions.GetCourseAndCreateEnrol) {
  try {
    const data = (yield call(handleGetCourse, action.payload)) as ICourseModel
    const { enrol, state } = data
    const isImparted = CourseStateType.Imparted === state
    if (!isImparted && !enrol && data.courseType === CourseType.Open) {
      const enrolCreated = yield enrolCreate({
        courseId: action.payload,
        note: '',
      }).then((res) => res.data)
      data.enrol = enrolCreated
    }
    if (data) yield put(fromActions.Actions.getCourseSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* getCourseAndCreateEnrolWatcherSaga() {
  yield takeLeading(
    fromActions.GET_COURSE_AND_CREATE_ENROL,
    getCourseAndCreateEnrol
  )
}
